import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Badge } from 'reactstrap';

import { faSquare, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAxiosInstance } from '../../utils/appWrapper';
import LabelBadges from '../LabelBadges';

function LabelSelect({ name, value, onChange, disabled, sessionUser }) {
  if (disabled) return <LabelBadges key={name} value={value} />;

  const [labels, setLabels] = React.useState([]);

  useEffect(() => {
    const axios = getAxiosInstance();
    axios.get('/labels?query[active]=true').then(res => {
      setLabels(_.sortBy(res.data.rows, 'owningSupplierOrganizationId'));
    });
  }, []);

  const isLabelInValueList = label => value?.some(v => v.id === label.id);

  const toggleLabel = label => {
    if (isLabelInValueList(label)) {
      onChange(
        name,
        value?.filter(v => v.id !== label.id),
      );
    } else {
      onChange(name, [
        ...value,
        { id: label.id, name: label.name, color: label.color },
      ]);
    }
  };

  const getLabelClass = label =>
    isLabelInValueList(label) ? 'badge-primary' : 'badge-secondary';

  const getLabelName = label => {
    if (sessionUser.roles === 'super') {
      return `${label.name} - ${
        label.owningSupplierOrganizationId
          ? label.owningSupplierOrganizationId
          : 'Flaivy Etikett'
      }`;
    }
    return label.name;
  };

  return (
    <div className="label-input">
      {labels.map(label => (
        <Badge
          key={label.id}
          color={isLabelInValueList(label) ? 'primary' : 'secondary'}
          className={`${getLabelClass(label)} mx-1 rounded-pill`}
          onClick={() => toggleLabel(label)}
        >
          <span className="h5 p-1">
            <FontAwesomeIcon
              icon={isLabelInValueList(label) ? faSquareCheck : faSquare}
            />{' '}
            {getLabelName(label)}
          </span>
        </Badge>
      ))}
    </div>
  );
}

LabelSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

LabelSelect.defaultProps = {
  value: [],
  disabled: false,
};

const mapStateToProps = ({ authentication }) => ({
  sessionUser: authentication.sessionUser,
});
export default connect(mapStateToProps)(LabelSelect);
